import { render } from "./AccountLedger.vue?vue&type=template&id=26033678&scoped=true"
import script from "./AccountLedger.vue?vue&type=script&lang=js"
export * from "./AccountLedger.vue?vue&type=script&lang=js"

import "./AccountLedger.vue?vue&type=style&index=0&id=26033678&scoped=true&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26033678"]])

export default __exports__